import React from 'react';
import { WHATSAPP_URL } from '../data/content';
const links = [{
  label: 'Política de privacidad',
  href: '#privacidad',
  external: false
}, {
  label: 'Términos del servicio',
  href: '#terminos',
  external: false
}, {
  label: 'Contacto por WhatsApp',
  href: WHATSAPP_URL,
  external: true
}];
export function SiteFooter() {
  return <footer className="border-t border-line bg-cream" data-id="element-209" data-mp="3hhwstgb6v0aa">
      <div className="mx-auto max-w-6xl px-5 py-14" data-id="element-210" data-mp="3dhe25pl1809o">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr]" data-id="element-211" data-mp="3deru7ou8biqx">
          <div data-id="element-212" data-mp="38gq9z0l2hddv">
            <p className="font-display text-2xl font-semibold text-ink" data-id="element-213" data-mp="38g6urrmsx33j">El Profe de Guitarra</p>
            <p className="mt-3 max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-214" data-mp="33j6y27budcp3">
              El sistema completo «Imprimí y enseñá» para profes de piano y guitarra.
            </p>
            <p className="mt-3 max-w-prose text-[13px] italic text-ink-mute" data-id="element-215" data-mp="11q0no6azyqmm">
              Porque enseñar música no debería costarte todos los domingos del año.
            </p>
          </div>

          <nav aria-label="Enlaces legales" className="lg:justify-self-end" data-id="element-216" data-mp="15ptusosu9kub">
            <ul className="flex flex-col gap-3 text-sm text-ink-soft sm:flex-row sm:gap-8 lg:flex-col lg:gap-3 lg:text-right" data-id="element-217" data-mp="1aqho5h4jidrp">
              {links.map(link => <li key={link.label} data-id="element-218" data-mp="vv213w2dni4t">
                  <a href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} className="transition-colors duration-150 ease-out hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-219" data-mp="10qz5d40d8y18">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-12 border-t border-line pt-6 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-220" data-mp="27ffiiy8do9oc">
          © 2026 El Profe de Guitarra — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}